module.exports = __webpack_public_path__ + "static/media/femaleWhite.8ae98649.svg";